
export default function Pagination({

    pagination,

    onPageChange

}){

    if(!pagination){

        return null;

    }

    const{

        page,

        pages,

        total,

        limit

    }=pagination;

    const start =
        total === 0
            ? 0
            : ((page - 1) * limit) + 1;

    const end =
        Math.min(
            page * limit,
            total
        );

    function changePage(next){

        if(

            next < 1 ||

            next > pages ||

            next === page

        ){

            return;

        }

        onPageChange?.(next);

    }

    function renderPages(){

        const buttons=[];

        if(pages<=7){

            for(

                let i=1;

                i<=pages;

                i++

            ){

                buttons.push(renderButton(i));

            }

            return buttons;

        }

        buttons.push(renderButton(1));

        if(page>4){

            buttons.push(renderDots("left"));

        }

        const startPage =
            Math.max(
                2,
                page-2
            );

        const endPage =
            Math.min(
                pages-1,
                page+2
            );

        for(

            let i=startPage;

            i<=endPage;

            i++

        ){

            buttons.push(renderButton(i));

        }

        if(page<pages-3){

            buttons.push(renderDots("right"));

        }

        buttons.push(
            renderButton(pages)
        );

        return buttons;

    }

    function renderButton(number){

        return(

            <button

                key={number}

                className={

                    number===page

                    ? "pagination-btn active"

                    : "pagination-btn"

                }

                onClick={()=>

                    changePage(number)

                }

            >

                {number}

            </button>

        );

    }

    function renderDots(key){

        return(

            <span

                key={key}

                className="pagination-dots"

            >

                ...

            </span>

        );

    }

    return(

        <div className="pagination">

            <div className="pagination-info">

                Showing

                {" "}

                {start}

                -

                {end}

                {" "}

                of

                {" "}

                {total}

            </div>

            <div className="pagination-controls">

                <button

                    className="pagination-btn"

                    disabled={page===1}

                    onClick={()=>

                        changePage(page-1)

                    }

                >

                    Previous

                </button>

                {

                    renderPages()

                }

                <button

                    className="pagination-btn"

                    disabled={page===pages}

                    onClick={()=>

                        changePage(page+1)

                    }

                >

                    Next

                </button>

            </div>
<style>{`.pagination{

    display:flex;

    justify-content:space-between;

    align-items:center;

    margin-top:24px;

    gap:20px;

    flex-wrap:wrap;

}

.pagination-info{

    color:#64748B;

    font-size:14px;

}

.pagination-controls{

    display:flex;

    align-items:center;

    gap:8px;

}

.pagination-btn{

    min-width:40px;

    height:40px;

    padding:0 14px;

    border:1px solid #D7DCE3;

    background:#FFF;

    border-radius:10px;

    cursor:pointer;

    transition:.2s;

}

.pagination-btn:hover:not(:disabled){

    border-color:#2563EB;

    color:#2563EB;

}

.pagination-btn.active{

    background:#2563EB;

    border-color:#2563EB;

    color:#FFF;

}

.pagination-btn:disabled{

    opacity:.45;

    cursor:not-allowed;

}
.pagination-dots{

    padding:0 8px;

    color:#64748B;

    font-weight:600;

    user-select:none;

}


`}</style>
        </div>

    );

}